export type AdminRole = 'brokerage' | 'marketing' | 'administration'

const EMAIL_TO_ROLE: Record<string, AdminRole> = {
    'broadcast@bso.ae': 'brokerage',
    'marketing@bso.ae': 'marketing',
    'reception@bso.ae': 'administration',
}

export const getAdminRole = (user?: { email?: string | null } | null): AdminRole | null => {
    const email = user?.email?.trim().toLowerCase()
    return email == null ? null : EMAIL_TO_ROLE[email] ?? null
}

export const adminRoleHomeRoute = (role: AdminRole): string => ({
    brokerage: '/landlord/my_units',
    marketing: '/landlord/insider',
    administration: '/landlord/key-viewings',
}[role])

export const isAdminRouteAllowed = (role: AdminRole, pathname: string): boolean => {
    if (role === 'brokerage') return !pathname.startsWith('/landlord/insider') && !pathname.startsWith('/landlord/sponsored_partners')
    if (role === 'marketing') return pathname.startsWith('/landlord/insider') || pathname.startsWith('/landlord/sponsored_partners')
    return pathname.startsWith('/landlord/key-viewings')
}
